/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResearchPurpose } from './ResearchPurpose';
import {
    ResearchPurposeFromJSON,
    ResearchPurposeFromJSONTyped,
    ResearchPurposeToJSON,
} from './ResearchPurpose';

/**
 * 
 * @export
 * @interface PreprodWorkspace
 */
export interface PreprodWorkspace {
    /**
     * ID of the workspace
     * @type {number}
     * @memberof PreprodWorkspace
     */
    workspaceId?: number;
    /**
     * Namespace of the preprod workspace
     * @type {string}
     * @memberof PreprodWorkspace
     */
    workspaceNamespace?: string;
    /**
     * The name of the workspace as displayed in the UI.
     * @type {string}
     * @memberof PreprodWorkspace
     */
    displayName: string;
    /**
     * The shortName corresponding to an access tier
     * @type {string}
     * @memberof PreprodWorkspace
     */
    accessTierShortName?: string;
    /**
     * ID corresponding to the CDR version
     * @type {number}
     * @memberof PreprodWorkspace
     */
    cdrVersionId?: number;
    /**
     * 
     * @type {ResearchPurpose}
     * @memberof PreprodWorkspace
     */
    researchPurpose?: ResearchPurpose;
}

/**
 * Check if a given object implements the PreprodWorkspace interface.
 */
export function instanceOfPreprodWorkspace(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;

    return isInstance;
}

export function PreprodWorkspaceFromJSON(json: any): PreprodWorkspace {
    return PreprodWorkspaceFromJSONTyped(json, false);
}

export function PreprodWorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreprodWorkspace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceId': !exists(json, 'workspaceId') ? undefined : json['workspaceId'],
        'workspaceNamespace': !exists(json, 'workspaceNamespace') ? undefined : json['workspaceNamespace'],
        'displayName': json['displayName'],
        'accessTierShortName': !exists(json, 'accessTierShortName') ? undefined : json['accessTierShortName'],
        'cdrVersionId': !exists(json, 'cdrVersionId') ? undefined : json['cdrVersionId'],
        'researchPurpose': !exists(json, 'researchPurpose') ? undefined : ResearchPurposeFromJSON(json['researchPurpose']),
    };
}

export function PreprodWorkspaceToJSON(value?: PreprodWorkspace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceId': value.workspaceId,
        'workspaceNamespace': value.workspaceNamespace,
        'displayName': value.displayName,
        'accessTierShortName': value.accessTierShortName,
        'cdrVersionId': value.cdrVersionId,
        'researchPurpose': ResearchPurposeToJSON(value.researchPurpose),
    };
}

